import React from 'react'
import Tooltip from 'app/theme/Tooltip'
import icon from 'assets/svg/verified.svg'

export default function VerifiedCheckmark(props) {
  return (
    <Tooltip content={<VerifiedText />}>
      <img src={icon} {...props} />
    </Tooltip>
  )
}

function VerifiedText() {
  return (
    <div className="p-2 leading-snug max-w-20">
      <div className="uppercase">
        Verified Caterer
      </div>
      <div className="font-light text-md">
        This caterer is insured and ready to cater your event
      </div>
    </div>
  )
}
